import { BeneficiaryKey } from "../../Benefit/beneficiary-key";

export class CardBlockDTO {
  constructor(private readonly beneficiaryKey: BeneficiaryKey, private readonly blockReason: string, private readonly includeDependents: boolean) {}

  getBeneficiaryKey(): BeneficiaryKey {
    return this.beneficiaryKey;
  }

  getBlockReason(): string {
    return this.blockReason;
  }

  getIncludeDependents(): boolean {
    return this.includeDependents;
  }
}
